module.exports = __webpack_public_path__ + "static/img/10.1973be9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/zh/10.png
// module id = vY6m
// module chunks = 0